import React, { useEffect } from "react";
import { Drawer, ScrollArea, Stack } from "@mantine/core";
import ClientDetails, { ClientDetailTab } from "./ClientDetails";
import { Client } from "../../types/client";

interface ClientDetailsDrawerProps {
  client: Client | null;
  opened: boolean;
  onClose: () => void;
  hideDeleteButton?: boolean;
  onClientUpdated?: (updatedClient: Client) => void;
  /** Tab to open on (defaults to "overview"). */
  initialTab?: ClientDetailTab;
  /**
   * Open a transaction's detail modal by UUID from the Activity Timeline. The
   * calendar passes this so its OWN full-screen modal opens over the drawer;
   * closing it returns to the still-open drawer.
   */
  onOpenTransaction?: (transactionId: string) => void;
}

const ClientDetailsDrawer = ({
  client,
  opened,
  onClose,
  hideDeleteButton = false,
  onClientUpdated,
  initialTab,
  onOpenTransaction,
}: ClientDetailsDrawerProps) => {
  useEffect(() => {
    if (client && onClientUpdated) {
      onClientUpdated(client);
    }
  }, [client, onClientUpdated]);

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title="Client Details"
      size="95%"
      position="right"
    >
      <ScrollArea>
        {client && (
          <Stack gap="md" p="xs">
            <ClientDetails
              client={client}
              onClose={onClose}
              hideDeleteButton={hideDeleteButton}
              initialTab={initialTab}
              onOpenTransaction={onOpenTransaction}
            />
          </Stack>
        )}
      </ScrollArea>
    </Drawer>
  );
};

export default ClientDetailsDrawer;
